import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import patient from "@/module/patient/card/chart/generate/patient"

export default function({ state, commit, dispatch }, patients) {
    commit('startCreatingPatient')
    dayjs.extend(utc)
    dayjs.extend(timezone)

    /**
     * Array of valid keys that are used in batch create API
     */
    const validKeyList = [
        'connect',
        'email',
        'name',
        'phone',
        'schedule',
        'reschedule'
    ]

    let createPatients = patients

    if(patients && Array.isArray(patients))
        createPatients = patients.map((patient) => {
            /**
             * Information related to patient schedule for the api
             */
            let patientScheduleInfo = {}
            validKeyList.forEach((key) => {
                // If the `key` holds an empty array the skip
                if(Array.isArray(patient[key]) && patient[key].length === 0)
                    return
                patientScheduleInfo[key] = patient[key]
            })

            try {
                if(state.timezone) {
                    let time = patient.schedule[0].time
                    let timeObj = new Date(time)
                    patient.schedule[0].time = dayjs.tz(timeObj.toISOString().split('T')[0] + ' 07:00',  state.timezone).valueOf() + 123
                }
            } catch (error) {
                console.error('Got error with schedule timing', error)
            }

            

            return patientScheduleInfo
        })

    return dispatch('post', {
        url: '/provider/' + state.id + '/patient',
        data: {
			batch: createPatients
		}
    }, {
        root: true
    })
    .then((response) => {
        commit('finishCreatingPatient')

        let patientSet = new Set()

        let uniquePatients = response.patient
            .filter((patient) => {
                if(!patientSet.has(patient.id)) {
                    patientSet.add(patient.id)
                    return true
                }
                return false
            })
		// Expect an array of added patients in the response
		uniquePatients.forEach((patient) => {
            if (! patient.error) {
                if(Array.isArray(patient.provider) && state.providers.some((provdrs) => patient.provider.includes(provdrs.provider))) {
                    commit('addPatient', patient)

                    const patAddToProv = state.providers.find((provdrs) => patient.provider.includes(provdrs.provider)).provider
                    let ovSite = JSON.parse(JSON.stringify(state.siteOverview))
                    let tempObj = {
                        count: ovSite[patAddToProv].count+1,
                        name: ovSite[patAddToProv].name
                    }
                    let finalObj = {
                        ...ovSite,
                        [patAddToProv]: {...tempObj}
                    }
                    commit('setProviderOverviewSite', finalObj)
                    commit('setAllPatientCount',state.allPatientCount+1)
                }
            }
        })
        try {
            const providerPatientMap = uniquePatients.reduce((providerAcc, patient) => {
                if(patient.provider && Array.isArray(patient.provider)) {
                    const currProvider = patient.provider[0]
                    if(providerAcc[currProvider])
                        providerAcc[currProvider].push(patient)
                    else
                        providerAcc[currProvider] = [patient]
                }
                return providerAcc
            }, {})
            dispatch('getProviderOverview', (state.id ? state.id : null))
            state.providers.forEach((provider) => dispatch('loadLineup', { id: provider.provider }))
            Object.entries(providerPatientMap).forEach(([id, patient]) => commit('addProviderPatientUpdate', {id, patient}))
        } catch (error) {
            console.error('Error in updating provider patient ', error)
        }
        

		// Pass to caller to check for errors in batch
		return response
    })
    .catch((error) => {
        commit('finishCreatingPatient')
		console.log(error)
		throw error
    })
}
